import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { INotifyResponse } from 'src/app/models/notify-response';
import { INotifyRequest } from 'src/app/models/notify-response';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProactiveBotNotificationService {

  constructor(private http: HttpClient,
    private configurationSettings: ConfigurationSettings) { }

  initiateProactiveNotification(notifyRequest: INotifyRequest): Observable<INotifyResponse> {
    return this.http.post<INotifyResponse>(this.configurationSettings.proactivenotification_api_endpoint + '/InitiateProactiveNotification', notifyRequest);
  };
}
